// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__26t3M","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2g1t2"};